export default __webpack_public_path__ + "static/media/RefundIssueUploadTemplate.c94295d3.xlsx";